import { render, staticRenderFns } from "./ReturnBatteryRule.vue?vue&type=template&id=6e383aa9&scoped=true"
import script from "./ReturnBatteryRule.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnBatteryRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReturnBatteryRule.vue?vue&type=style&index=0&id=6e383aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e383aa9",
  null
  
)

export default component.exports